/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=brands&m=free */

import {
    faBootstrap,
    faCcAmex,
    faCcDinersClub,
    faCcDiscover,
    faCcJcb,
    faCcMastercard,
    faCcVisa,
    faFacebook,
    faFacebookF,
    faGithub,
    faGoogle,
    faHtml5,
    faTwitter,
    faWhatsapp,
} from '@fortawesome/free-brands-svg-icons';

export const fontAwesomeBrandsIcons = {
    faBootstrap,
    faCcAmex,
    faCcDinersClub,
    faCcDiscover,
    faCcJcb,
    faCcMastercard,
    faCcVisa,
    faFacebook,
    faFacebookF,
    faGithub,
    faGoogle,
    faHtml5,
    faTwitter,
    faWhatsapp,
};
